export default {
    recordDetails: {
        enableInventory: "Activer le suivi du stock",
        inventoryDisabled: "Le suivi du stock est désactivé",
        inventoryEnabled: "Suivi du stock activé",
        inventorySaved: "Ajustement du stock enregistré",
        itemTitle: "Détails de l’article",
        expenseTitle: "Détails de la dépense",
        timeTitle: "Détails du temps suivi",
        information: "Détails",
        receipt: "Reçu",
        inventoryHistory: "Historique du stock",
        inventoryLoadFailed: "Impossible de charger l’historique du stock.",
        noInventory: "Aucun mouvement de stock",
        loadFailed: "Impossible de charger les détails.",
        deleteConfirm: "Supprimer cet enregistrement ?",
        deleted: "Enregistrement supprimé"
    },
    common: {
        appName: 'Swift Invoice',
        back: 'Retour',
        cancel: 'Annuler',
        email: 'E-mail',
        password: 'Mot de passe',
        or: 'ou',
        change: 'Changer',
        delete: 'Supprimer',
        save: 'Enregistrer',
        edit: 'Modifier',
        add: 'Ajouter',
        close: 'Fermer',
        date: 'Date',
        total: 'Total',
        status: 'Statut',
        amount: 'Montant',
        quantity: 'Quantité',
        rate: 'Tarif',
        tax: 'Taxe',
        discount: 'Remise',
        note: 'Note',
        notes: 'Notes',
        noData: 'Aucune donnée',
        description: 'Description',
        client: 'Client',
        item: 'Article',
        items: 'Articles',
        type: 'Type',
        category: 'Catégorie',
        phone: 'Téléphone',
        name: 'Nom',
        subject: 'Objet',
        saveAndClose: 'Enregistrer et fermer',
        saveAndSendEmail: 'Enregistrer et envoyer un e-mail',
        sendEmail: 'Envoyer un e-mail',
        send: 'Envoyer',
        print: 'Imprimer',
        moreActions: 'Plus d’actions',
        preparingPdf: 'Préparation du PDF...',
        pdfPreparationFailed: 'Impossible de préparer le PDF',
        warning: 'Avertissement',
        ok: 'OK',
        uploadSuccess: 'téléversement réussi',
        saveSuccess: 'enregistrement réussi',
        deleteSuccess: 'suppression réussie',
        deleteFailed: 'suppression échouée',
        saveFailed: 'enregistrement échoué',
        loadFailed: 'chargement échoué',
        systemError: 'erreur système',
        sendSuccess: 'envoi réussi',
        updateSuccess: 'mise à jour réussie',
        unsavedChangesMsg: 'Vous avez des modifications non enregistrées. Voulez-vous les enregistrer ou les abandonner ?',
        saveChangesTitle: 'Enregistrer les modifications ?',
        confirmSave: 'Enregistrer',
        discard: 'Abandonner',
        validEmail: 'Veuillez saisir une adresse e-mail valide',
        deleteFailedMsg: 'suppression échouée',
        shipping: 'Livraison',
        attachment: 'Pièce jointe',
        days: 'Jours',
        excl: '(HT)',
        incl: '(TTC)',
        of: 'de',
        batchActions: 'Actions groupées',
        selected: 'sélectionnés',
        select: 'Sélectionner',
        batchDeleteConfirm: 'Supprimer les {count} éléments sélectionnés ?',
        batchActionSuccess: '{count} éléments mis à jour',
        batchActionPartial: '{processed} éléments mis à jour ; {skipped} sans modification',
        batchEmailInvalidRecipients: 'Ajoutez un destinataire valide à chaque document',
        batchEmailSent: '{count} e-mails envoyés',
        batchEmailPartial: '{sent} e-mails envoyés ; {failed} échecs',
        emailHtmlNotAllowed: 'Le sujet et le message de l’e-mail ne peuvent pas contenir de HTML.'
    },
    emailVerification: {
        title: 'Vérifiez votre adresse e-mail',
        description: 'Nous avons envoyé un code à votre adresse e-mail de connexion :',
        codePlaceholder: 'Saisissez le code de vérification',
        enterCode: 'Saisissez le code reçu par e-mail pour continuer.',
        sent: 'Code de vérification envoyé.',
        resent: 'Un nouveau code de vérification a été envoyé.',
        validFor: 'Le code est valable pendant 10 minutes.',
        verify: 'Vérifier',
        resend: 'Renvoyer',
        success: 'Adresse e-mail vérifiée. Votre e-mail va être envoyé.',
        failed: 'Le code de vérification est incorrect ou a expiré.',
        limitReached: "La limite d'envoi du jour est atteinte.",
        remaining: '{count} envois restants aujourd’hui',
        contactUs: 'Nous contacter'
    },
    login: {
        heroPrefix: 'Facturation ',
        heroInvoicing: 'intelligente',
        heroMiddle: ',',
        heroSimplified: 'simplifiée',
        heroSuffix: ' pour vous.',
        subtitle1: 'Créez, envoyez et gérez vos factures sans effort.',
        subtitle2: 'Soyez payé plus rapidement avec Swift Invoice.',
        feature1Title: 'Factures professionnelles',
        feature1Text: 'Créez de belles factures en quelques minutes',
        feature2Title: 'Suivi en temps réel',
        feature2Text: 'Suivez les paiements et le statut des factures',
        feature3Title: 'Sécurisé et fiable',
        feature3Text: 'Vos données sont en sécurité avec une sécurité de niveau entreprise',
        welcomeBack: 'Bon retour',
        signInToContinue: 'Connectez-vous à votre compte pour continuer',
        enterEmail: 'Saisissez votre e-mail',
        enterPassword: 'Saisissez votre mot de passe',
        rememberMe: 'Se souvenir de moi',
        forgotPassword: 'Mot de passe oublié ?',
        signIn: 'Se connecter',
        signingIn: 'Connexion…',
        continueWithGoogle: 'Continuer avec Google',
        continueWithApple: 'Continuer avec Apple',
        createAccount: 'Créer un compte',
        startUsing: 'Commencer avec Swift Invoice',
        companyName: "Nom de l'entreprise",
        enterCompanyName: 'Saisissez le nom de votre entreprise',
        alreadyHaveAccount: 'Vous avez déjà un compte ? Connectez-vous',
        footerRights: '© 2026 Swift Invoice. Tous droits réservés.',
        termsOfService: "Conditions d'utilisation",
        contactUs: 'Contactez-nous : goodinvoicego@gmail.com',
        betaDialogBody: "Notre équipe a terminé la première version du web <br> Cette version sera uniquement disponible pour les utilisateurs iPhone <br> Nous améliorerons la fonctionnalité web dès que possible et l'ouvrirons à tous <br>",
        ieDialogBody: "Désolé, en raison de problèmes de compatibilité du navigateur IE, nous ne prenons pas en charge le navigateur IE pour le moment. Si vous devez l'utiliser, veuillez le télécharger",
        resetPasswordTitle: 'Réinitialiser le mot de passe',
        sendResetEmail: "Envoyer l'e-mail de réinitialisation",
        resetEmailSent: "E-mail de réinitialisation du mot de passe envoyé. Veuillez vérifier votre boîte de réception.",
        bindingTitle: 'Lier un compte existant',
        bindingHintPrefix: "Un compte utilise déjà l'e-mail ",
        bindingHintSuffix: ". Saisissez le mot de passe de ce compte pour lier votre connexion Google.",
        enterAccountPassword: 'Saisissez le mot de passe du compte',
        linkAccount: 'Lier le compte',
        validEmail: 'Veuillez saisir une adresse e-mail valide',
        validPassword: 'Le mot de passe doit comporter 6 caractères ou plus',
        validCompanyName: 'Veuillez remplir le nom de votre entreprise',
        companyNameTooLong: 'Le nom de l’entreprise peut contenir jusqu’à {max} caractères',
        turnstileUnavailable: 'Le contrôle de sécurité n’a pas pu être chargé. Réessayez.',
        turnstileExpired: 'Le contrôle de sécurité a expiré. Veuillez le refaire.',
        accountDataLoadFailed: 'Le compte a été vérifié, mais les données de l’entreprise n’ont pas pu être chargées. Réessayez.'
    },
    account: {
        title: 'Compte',
        profile: 'Profil',
        swiftAccount: 'Compte Swift Invoice',
        connectSocial: 'Connecter les comptes sociaux',
        companyLogo: "Logo de l'entreprise",
        logoSize: 'Taille du logo',
        hideBusinessName: 'Masquer le nom de l’entreprise',
        businessNameSize: 'Taille du nom de l’entreprise',
        sizeSmall: 'Petite',
        sizeNormal: 'Normale',
        sizeBig: 'Grande',
        addLogo: 'Ajouter un logo',
        uploading: 'téléversement...',
        currentPlan: 'Plan actuel : Swift {plan}',
        planActiveUntil: "Plan actif jusqu'au {date}",
        sharedWithMobile: 'Partagé avec le mobile',
        subscriptionExpired: 'Votre abonnement a expiré',
        planNote: "Reconnectez-vous si votre statut d'abonnement n'a pas été mis à jour.",
        upgradeToPro: 'Passer à Swift Pro',
        viewPlans: "Voir les offres d'abonnement",
        connecting: 'Connexion…',
        connectGoogle: 'Connecter Google',
        googleConnected: 'Google connecté',
        googleConnectedWithEmail: 'Google connecté ({email})',
        connectApple: 'Connecter Apple',
        appleConnected: 'Apple connecté',
        appleConnectedWithEmail: 'Apple connecté ({email})',
        logoUuidMissing: "L'UUID du logo de l'entreprise est manquant",
        googleConnectedToast: 'Compte Google connecté.',
        appleConnectedToast: 'Compte Apple connecté.',
        logoUploadEmpty: 'Veuillez sélectionner une image.',
        logoUploadSize: "L’image ne peut pas dépasser 10 Mo.",
        logoUploadType: 'Seules les images JPEG, PNG et BMP sont prises en charge.',
        logoUploadFailed: "Le logo de l’entreprise n’a pas pu être envoyé.",
        logoUnavailable: "Le fichier du logo est indisponible. Envoyez-le à nouveau.",
        deleteAccount: 'Supprimer le compte',
        deleteAccountDescription: 'Fermez définitivement votre compte Swift Invoice.',
        deleteAccountTitle: 'Supprimer le compte ?',
        deleteAccountWarning: 'Cette action est irréversible.',
        deleteAccountConfirm: 'Saisissez votre mot de passe pour confirmer la suppression du compte.',
        deleteAccountPasswordPlaceholder: 'Saisissez votre mot de passe'
    },
    menu: {
        openNavigation: 'Ouvrir la navigation',
        closeNavigation: 'Fermer la navigation',
        invoices: 'Factures',
        estimates: 'Devis',
        purchaseOrders: 'Bons de commande',
        creditMemos: 'Avoirs',
        time: 'Temps',
        items: 'Articles',
        clients: 'Clients',
        expenses: 'Dépenses',
        reports: 'Rapports',
        settings: 'Paramètres',
        companyInfo: "Informations sur l'entreprise",
        taxes: 'Taxes',
        default: 'Par défaut',
        customizeInvoice: 'Personnaliser la facture',
        sendFeedback: 'Envoyer un commentaire',
        newReply: '1 nouvelle réponse',
        signOut: 'Se déconnecter',
        signOutConfirm: 'Êtes-vous sûr de vouloir vous déconnecter ?',
        addBusiness: 'Ajouter une entreprise',
        newBusinessTitle: 'Nouvelle entreprise',
        businessName: "Nom de l’entreprise",
        businessNamePlaceholder: "Saisissez le nom de l’entreprise",
        createBusiness: 'Créer',
        businessNameRequired: "Saisissez le nom de l’entreprise",
        createBusinessSuccess: 'Entreprise créée',
        deleteBusiness: "Supprimer l’entreprise",
        deleteBusinessTitle: "Supprimer l’entreprise",
        deleteBusinessConfirm: 'Supprimer « {name} » ?',
        deleteBusinessWarning: 'Toutes les données de cette entreprise seront supprimées.',
        deleteBusinessSuccess: 'Entreprise supprimée avec succès',
        trialDaysLeft: 'Il reste {days} jours d’essai',
        upgradeAccount: 'Mettre à niveau'
    },
    network: {
        loginExpired: 'Connexion expirée, veuillez vous reconnecter',
        requestTimeout: 'Délai de demande dépassé, veuillez vérifier le réseau'
    },
    language: {
        label: 'Langue',
        zh: '中文',
        en: 'English'
    },
    invoice: {
        listLoadFailed: 'Impossible de charger les factures.',
        summaryLoadFailed: 'Impossible de charger les totaux des factures.',
        invoiceNumberPlaceholder: 'Saisir le n° de facture',
        filterAllClients: 'Tous les clients',
        clientOptionsLoadFailed: 'Impossible de charger les clients pour le filtrage.',
        filterAllStatuses: 'Tous les statuts',
        filterUnpaid: 'Impayée',
        filterPaid: 'Payée',
        filterOverdue: 'En retard',
        filterUnsent: 'Non envoyée',
        filterSent: 'Envoyée',
        filterStartDate: 'Date de début',
        filterEndDate: 'Date de fin',
        searchPlaceholder: 'Rechercher vos factures',
        addInvoice: 'Ajouter une facture',
        overdueInvoices: 'Factures en retard',
        paidInvoices: 'Factures payées',
        unpaidInvoices: 'Factures impayées',
        unsentInvoices: 'Factures non envoyées',
        columnNumber: 'Numéro',
        columnClient: 'Client',
        columnStatus: 'Statut',
        statusFullyPaid: 'Entièrement payée',
        statusPartial: 'Partielle',
        statusOverdue: 'En retard',
        statusUnsent: 'Non envoyée',
        statusSent: 'Envoyée',
        statusOpened: 'Ouverte',
        actionRecordPayment: 'Enregistrer le paiement',
        actionMarkAsSent: 'Marquer comme envoyée',
        actionCopy: 'Copier',
        actionDelete: 'Supprimer',
        copyDialogTitle: 'Copier la facture',
        copyTargetType: 'Copier vers',
        copyOptions: 'Options de copie',
        copyClient: 'Copier le client',
        copyItems: 'Copier les articles',
        copyAttachments: 'Copier les pièces jointes',
        confirmDelete: 'Cela supprimera la facture. Continuer ?',
        copySuccess: 'Facture copiée',
        copyFailed: 'Échec de la copie',
        deleteSuccess: 'Facture supprimée',
        deleteFailed: 'Échec de la suppression',
        recordPaymentDialogTitle: 'Enregistrer le paiement',
        markAsFullyPaid: 'Marquer comme entièrement payée',
        formAmount: 'Montant',
        formDate: 'Date',
        formPaymentMethod: 'Mode de paiement',
        formNote: 'Note',
        allYears: 'Toutes les années',
        errorNoOutstandingBalance: 'Aucun solde impayé n’est disponible pour le paiement',
        errorInvalidPaymentAmount: 'Saisissez un montant supérieur à zéro avec au maximum 5 décimales',
        dueDateToday: "Aujourd'hui",
        dueDateDaysAgo: '{days} jours',
        dueDateInDays: 'dans {days} jours'
    },
    estimate: {
        filterAllStatuses: 'Tous les statuts',
        pageTitlePurchaseOrders: 'Bons de commande',
        pageTitleEstimates: 'Devis',
        pageTitleCreditMemos: 'Avoirs',
        searchPlaceholderPurchaseOrders: 'Rechercher vos bons de commande',
        searchPlaceholderEstimates: 'Rechercher vos devis',
        searchPlaceholderCreditMemos: 'Rechercher vos avoirs',
        addPurchaseOrder: 'Ajouter un bon de commande',
        addEstimate: 'Ajouter un devis',
        addCreditMemo: 'Ajouter un avoir',
        columnNumber: 'Numéro',
        columnClient: 'Client',
        columnDate: 'Date',
        columnEmail: 'E-mail',
        columnStatus: 'Statut',
        columnTotal: 'Total',
        statusUnsent: 'Non envoyé',
        statusSent: 'Envoyé',
        actionMarkAsSent: 'Marquer comme envoyé',
        actionCopy: 'Copier',
        actionDelete: 'Supprimer',
        actionConvertToInvoice: 'Convertir en facture',
        copyDialogTitle: 'Copier {document}',
        copyTargetType: 'Copier vers',
        copyOptions: 'Options de copie',
        copyClient: 'Copier le client',
        copyItems: 'Copier les articles',
        copyAttachments: 'Copier les pièces jointes',
        confirmDelete: 'Cela supprimera {document}. Continuer ?',
        convertConfirm: "Convertir ce {document} en facture ? La date sera définie à aujourd'hui.",
        copySuccess: '{document} copié',
        copyFailed: 'Échec de la copie',
        convertSuccess: '{document} converti en facture',
        convertFailed: 'Échec de la conversion',
        deleteSuccess: '{document} supprimé',
        deleteFailed: 'Échec de la suppression',
        dueDateToday: "Aujourd'hui",
        dueDateDaysAgo: '{days} jours',
        dueDateInDays: 'dans {days} jours'
    },
    item: {
        pageTitle: 'Articles',
        searchPlaceholder: 'Rechercher vos articles',
        addItem: 'Ajouter un article',
        columnInventoryCountUnit: 'Stock/Unité',
        noDescription: 'Aucune description de l’article'
    },
    client: {
        detailsTitle: 'Détails du client',
        contactDetails: 'Coordonnées',
        invoiceHistory: 'Historique des factures',
        noInvoices: 'Aucune facture pour le moment',
        retry: 'Réessayer',
        detailsLoadFailed: 'Impossible de charger les détails du client.',
        invoicesLoadFailed: 'Impossible de charger les factures.',
        deleteConfirm: 'Supprimer ce client ?',
        deleted: 'Client supprimé',
        pageTitle: 'Clients',
        searchPlaceholder: 'Rechercher vos clients',
        addClient: 'Ajouter un client',
        columnClientName: 'Nom du client',
        columnEmail: 'E-mail',
        columnPhone: 'Téléphone',
        columnBalanceDue: 'Solde dû',
        noNameFallback: 'SANS NOM'
    },
    expense: {
        pageTitle: 'Dépenses',
        searchPlaceholder: 'Rechercher vos dépenses',
        allCategories: 'Toutes les catégories',
        noCategory: 'Sans catégorie',
        categoryLoadFailed: 'Impossible de charger les catégories de dépenses.',
        addExpense: 'Ajouter une dépense',
        columnDescription: 'Description',
        columnDate: 'Date',
        columnTotal: 'Total',
        tip: 'Pourboire'
    },
    report: {
        headerTitle: 'Rapports',
        tabDashboard: 'Tableau de bord',
        tabReportList: 'Liste des rapports',
        export: 'Exporter',
        annualSalesByClient: 'Ventes annuelles par client',
        otherClients: 'Autres clients',
        totalOutstandingBalance: 'Solde impayé total',
        invoicesCountSuffix: 'factures',
        byMonth: 'Par mois',
        byQuarter: 'Par trimestre',
        noSalesFound: 'Aucune vente trouvée',
        filterReportTypes: 'Types de rapports',
        filterTimePeriod: 'Période',
        filterView: 'Affichage',
        filterTaxYear: 'Année fiscale',
        filterQuarter: 'Trimestre',
        filterMonth: 'Mois',
        filterStartDate: 'Date de début',
        filterEndDate: 'Date de fin',
        invalidCustomDateRange: 'La date de début ne peut pas être postérieure à la date de fin',
        searchClientName: 'Rechercher un nom de client',
        searchItemName: 'Rechercher un nom d’article',
        searchSalesJournal: 'Rechercher un numéro de facture ou un nom de client',
        searchPaymentsJournal: 'Rechercher un numéro de facture, un nom de client ou un type de paiement',
        periodMonth: 'Mois',
        periodQuarter: 'Trimestre',
        periodYear: 'Année',
        periodAllTaxYears: 'Toutes les années fiscales',
        periodCustom: 'Personnalisé',
        taxYearLabel: 'Année fiscale {year}',
        quarterLabel: 'T{quarter} Année fiscale {year}',
        optionMonthly: 'Mensuel',
        optionQuarterly: 'Trimestriel',
        customerAgingTitle: 'Ancienneté client',
        noDataForDateRange: 'Aucune donnée pour cette période',
        typeSalesByDate: 'Ventes par date',
        typeSalesByClient: 'Ventes par client',
        typeSalesByItem: 'Ventes par article',
        typeSalesJournal: 'Journal des ventes',
        typePaymentsByDate: 'Paiements par date',
        typePaymentsByClient: 'Paiements par client',
        typePaymentsByType: 'Paiements par type',
        typePaymentsJournal: 'Journal des paiements',
        typeExpenseByCategory: 'Dépenses par catégorie',
        typeExpenseJournal: 'Journal des dépenses',
        typeProfitLoss: 'Résultat',
        typeTaxes: 'Taxes',
        typeCustomerAging: 'Ancienneté client',
        allYears: 'Toutes les années',
        allTime: 'Toute la période',
        allSales: 'Toutes les ventes',
        taxYearSales: "Ventes de l'exercice fiscal {year}",
        firstColumnMonth: 'Mois',
        firstColumnQuarter: 'Trimestre',
        firstColumnYear: 'Année',
        firstColumnDay: 'Jour',
        firstColumnDate: 'Date',
        columnSubTotal: 'Sous-total',
        columnTax: 'Taxe',
        columnDiscount: 'Remise',
        columnTotal: 'Total',
        columnAmountPaid: 'Montant payé',
        columnAmountOwed: 'Montant dû',
        columnClient: 'Client',
        columnItem: 'Article',
        columnUnitType: "Type d'unité",
        columnQuantity: 'Quantité',
        columnRateAvg: 'Tarif (moy.)',
        columnInvoiceDate: 'Date de facture',
        columnInvoiceNo: 'N° de facture',
        columnType: 'Type',
        columnPaymentDate: 'Date de paiement',
        columnCategory: 'Catégorie',
        columnExpenseDate: 'Date de dépense',
        columnMerchant: 'Marchand',
        columnDescription: 'Description',
        columnCurrentDue: 'Dû actuel',
        column1To30DaysOverdue: '1-30 jours de retard',
        column31To60DaysOverdue: '31-60 jours de retard',
        column61To90DaysOverdue: '61-90 jours de retard',
        column91PlusDaysOverdue: '91+ jours de retard',
        columnSection: 'Section',
        columnAmount: 'Montant',
        columnPreTaxSales: 'Ventes hors taxes',
        columnTaxLabel: 'Libellé de taxe',
        columnTaxRate: 'Taux de taxe',
        columnTotalTax: 'Total des taxes',
        columnPostTaxTotal: 'Total taxes comprises',
        profitLossTitle: 'Résultat',
        taxesTitle: 'Taxes',
        profitLossRevenue: 'Revenus',
        profitLossExpense: 'Dépenses',
        profitLossProfit: 'Bénéfice',
        profitLossCash: 'Trésorerie',
        profitLossAccrued: 'Comptabilisé',
        profitLossAccountsReceivables: 'Créances clients',
        profitLossNone: '[Aucune]',
        profitLossTotalExpenses: 'Total des dépenses',
        profitLossCashProfit: 'Bénéfice de trésorerie',
        profitLossAccruedProfit: 'Bénéfice comptabilisé',
        monthNames: 'Janv, Févr, Mars, Avr, Mai, Juin, Juil, Août, Sept, Oct, Nov, Déc',
        totalRowLabel: 'Total'
    },
    invoiceCreate: {
        pageTitlePrefix: 'Ajouter',
        initialDataLoadFailed: 'Impossible de charger les paramètres du document. La modification et l’enregistrement sont désactivés.',
        searchSuggestionsLoadFailed: 'Impossible de charger les suggestions de recherche.',
        invoicePrefix: 'préfixe de facture',
        tabCreate: 'Créer',
        tabPreview: 'Aperçu',
        tabSendEmail: 'Envoyer un e-mail',
        sectionClient: 'Client',
        addClient: 'Ajouter un client',
        dialogClientInfo: 'Informations sur le client',
        basicInformation: 'Informations de base',
        labelName: 'Nom',
        labelEmail: 'E-mail',
        labelPhone: 'Téléphone',
        billingAddress: 'Adresse de facturation',
        labelLine1: 'Ligne 1',
        labelLine2: 'Ligne 2',
        labelLine3: 'Ligne 3',
        shippingAddress: 'Adresse de livraison',
        labelShippingName: 'Nom de livraison',
        labelNotes: 'Notes',
        placeholderCreateOrSelect: 'Créer ou sélectionner un...',
        placeholderClientNotes: "Ajoutez des notes sur le client. Ils ne peuvent pas les voir",
        sectionItems: 'Articles',
        saveToYourItem: 'Enregistrer dans votre article',
        stock: 'Stock :',
        placeholderItemCode: 'code article',
        placeholderQuantity: 'Quantité',
        placeholderRate: 'tarif',
        placeholderInputDescription: 'Saisir une description',
        placeholderInputComment: 'Saisir un commentaire',
        placeholderAddRecipient: 'Ajouter un destinataire',
        cc: 'Cc',
        bcc: 'Cci',
        placeholderEmailSubject: "Objet de l'e-mail",
        placeholderMessage: 'Écrivez votre message...',
        labelTo: 'À',
        labelSubject: 'Objet',
        sectionAttachments: 'Pièces jointes',
        sectionComment: 'Commentaire',
        addItem: 'Ajouter un article',
        addPhoto: 'Ajouter une photo',
        addPayment: 'Ajouter un paiement',
        goBack: 'retour',
        dialogShippingInfo: 'Informations de livraison',
        dialogRecordPayment: 'Enregistrer le paiement',
        dialogJobDetails: 'Détails du travail',
        labelAmount: 'Montant',
        labelShipDate: "Date d'expédition",
        labelShipVia: 'Expédier via',
        labelTrackingNumber: 'Numéro de suivi',
        labelFob: 'FOB',
        columnDate: 'Date',
        columnType: 'Type',
        msgClientEmailError: "erreur d'e-mail du client",
        msgAmountGreaterThanZero: 'Le montant doit être supérieur à zéro',
        msgInvalidAmount: 'Le montant doit être compris entre 0 et 999 999 999 999 999 avec au maximum 5 décimales',
        calculatedAmountOutOfRange: 'Le montant calculé dépasse la plage prise en charge',
        msgTextTooLong: '{field} ne peut pas dépasser {max} caractères',
        msgTextTooLongBytes: '{field} ne peut pas dépasser {max} octets UTF-8',
        msgInvalidJobDetails: 'Les détails du travail contiennent des données non valides',
        msgMorePaymentThanBalance: 'Paiement supérieur au solde dû',
        mailSentSuccessfully: 'E-mail envoyé avec succès',
        cumulativeTaxNotice: "Le web ne prend pas en charge l'accumulation de taxes dans la facture...",
        confirmUnsavedChanges: 'Vous avez des modifications non enregistrées. Voulez-vous les enregistrer ou les abandonner ?',
        pdf: 'PDF',
        taxDiscountWithholding: 'Taxe, remise et retenue',
        purchaseOrder: 'Bon de commande',
        placeholderPurchaseOrderPrefix: 'préfixe de bon de commande',
        placeholderCreditMemoPrefix: 'préfixe d’avoir',
        placeholderEstimatePrefix: 'préfixe de devis',
        labelStatus: 'Statut',
        statusIssued: 'Émis',
        statusApproved: 'Approuvé',
        statusPending: 'En attente',
        statusWithdrawn: 'Retiré',
        tax: 'Taxe'
    },
    createEstimate: {
        pageTitlePrefix: 'Ajouter',
        cumulativeTaxNotice: "Le web ne prend pas en charge l'accumulation de taxes dans le devis..."
    },
    updateInvoice: {
        pageTitlePrefix: 'Mettre à jour',
        deletePrefix: 'Supprimer',
        confirmDelete: 'Cela supprimera la facture. Continuer ?',
        cumulativeTaxNotice: 'Cette facture contient une taxe cumulative. Le web ne prend pas en charge cette fonction pour le moment'
    },
    updateEstimate: {
        pageTitlePrefix: 'Mettre à jour',
        deletePrefix: 'Supprimer',
        confirmDelete: 'Cela supprimera le {document}. Continuer ?',
        cumulativeTaxNotice: 'Ce devis contient une taxe cumulative. Le web ne prend pas en charge cette fonction pour le moment'
    },
    createAccount: {
        title: 'Créer un compte',
        placeholderEmail: 'e-mail',
        placeholderPassword: 'Mot de passe',
        placeholderCompanyName: "Nom de l'entreprise",
        createAccountButton: 'Créer un compte',
        alreadyHaveAccount: 'Vous avez déjà un compte ?',
        signIn: 'Se connecter',
        validEmail: 'Veuillez saisir une adresse e-mail valide',
        validPassword: 'Le mot de passe doit comporter 6 caractères ou plus',
        validCompanyName: 'Veuillez remplir le nom de votre entreprise',
        companyNameTooLong: 'Le nom de l’entreprise peut contenir jusqu’à {max} caractères'
    },
    clientCreate: {
        pageTitle: 'Ajouter un client',
        basicInformation: 'Informations de base',
        labelName: 'Nom',
        placeholderName: 'Saisir un nom...',
        labelEmail: 'E-mail',
        placeholderEmail: 'Saisir une adresse e-mail...',
        labelPhone: 'Téléphone',
        placeholderPhone: 'Saisir un numéro de téléphone...',
        billingAddress: 'Adresse de facturation',
        labelLine1: 'Ligne 1',
        labelLine2: 'Ligne 2',
        labelLine3: 'Ligne 3',
        shippingAddress: 'Adresse de livraison',
        sameAsBilling: "Identique à l'adresse de facturation",
        labelShippingName: 'Nom de livraison',
        labelShippingLine1: 'Ligne 1',
        labelShippingLine2: 'Ligne 2',
        labelShippingLine3: 'Ligne 3',
        labelNotes: 'Notes',
        placeholderNotes: "Ajoutez des notes sur le client. Ils ne peuvent pas les voir",
        defaultDiscount: 'Remise par défaut',
        validDefaultDiscount: 'Saisissez une remise par défaut valide',
        validName: 'Veuillez saisir le nom du client',
        validEmail: 'Veuillez saisir une adresse e-mail valide'
    },
    clientUpdate: {
        pageTitle: 'Mettre à jour le client',
        confirmDelete: 'Cela supprimera le client. Continuer ?'
    },
    itemCreate: {
        pageTitle: 'Ajouter un article',
        itemTitle: 'Article',
        labelCost: 'Coût',
        rateSign: 'Signe du tarif',
        inventorySign: 'Signe de l’ajustement du stock',
        labelUnit: 'Unité',
        placeholderUnit: 'Unité',
        defaultTaxes: 'Taxes par défaut',
        taxOff: 'désactivé',
        inventoryTitle: 'Inventaire',
        currentInventory: 'Inventaire actuel',
        adjustInventory: "Ajuster l'inventaire",
        increase: 'Augmenter',
        decrease: 'Diminuer',
        placeholderQuantity: 'Quantité',
        placeholderDateAndTime: 'Date et heure',
        placeholderNote: 'Note',
        addButton: 'Ajouter',
        columnDate: 'Date',
        columnQuantity: 'Quantité',
        columnNote: 'Note',
        withholdingTitle: 'Retenue',
        msgInventoryCannotDisable: "L'inventaire ne peut pas être désactivé après avoir été activé",
        msgDescriptionRequired: "La description de l'article est obligatoire",
        msgInvalidRate: 'Le tarif doit être compris entre -999 999 999 999 999 et 999 999 999 999 999 et comporter au maximum 4 décimales',
        msgInvalidCost: 'Le coût doit être compris entre 0 et 999 999 999 999 999 et comporter au maximum 5 décimales',
        msgInvalidInventory: 'La quantité doit être comprise entre 0 et 999 999 999 999 999 et comporter au maximum 5 décimales',
        msgInvalidUnit: 'L’unité ne doit pas contenir && ni dépasser 255 caractères',
        msgQuantityRequired: 'La quantité est requise',
        msgDateRequired: "La date et l'heure sont requises"
    },
    itemUpdate: {
        pageTitle: "Modifier l'article",
        columnInvoice: 'Facture',
        confirmDelete: "Cela supprimera l'article. Continuer ?"
    },
    createStatement: {
        pageTitle: 'Relevé',
        tabPreview: 'Aperçu',
        tabSendEmail: 'Envoyer un e-mail',
        createAction: 'Créer un relevé',
        from: 'Du',
        to: 'Au',
        invoices: 'Factures',
        balanceDue: 'Solde dû',
        editTitle: 'Modifier le relevé',
        startDate: 'Date de début',
        endDate: 'Date de fin',
        onlyShowUnpaid: 'Afficher uniquement les factures impayées',
        unpaidOnlyActive: 'Ce relevé contient uniquement les factures impayées.',
        dateRequired: 'Les dates de début et de fin sont obligatoires',
        invalidDateRange: 'La date de fin ne peut pas précéder la date de début'
    },
    time: {
        pageTitle: 'Temps',
        unbilled: 'Non facturé',
        billed: 'Facturé',
        searchPlaceholder: 'Rechercher par client ou description',
        addTime: 'Ajouter du temps',
        noTime: 'Aucune saisie de temps',
        noTimeDescription: 'Créez une saisie pour suivre le travail facturable.',
        noClient: 'Aucun client',
        filterAndSort: 'Filtrer et trier',
        year: 'Année',
        groupBy: 'Regrouper par',
        sortBy: 'Trier par',
        order: 'Ordre',
        yearly: 'Annuel',
        quarterly: 'Trimestriel',
        monthly: 'Mensuel',
        ascending: 'Croissant',
        descending: 'Décroissant',
        duration: 'Durée',
        createTitle: 'Créer une saisie de temps',
        editTitle: 'Temps',
        selectClient: 'Sélectionner un client',
        start: 'Début',
        end: 'Fin',
        hours: 'heures',
        minutes: 'minutes',
        ratePreset: 'Tarif',
        customRate: 'Tarif personnalisé',
        rateName: 'Nom du tarif',
        showRateName: 'Afficher le nom du tarif sur la facture',
        invalidDate: 'Les heures de début et de fin sont requises',
        endBeforeStart: "L'heure de fin ne peut pas précéder l'heure de début",
        invalidDuration: 'La durée doit correspondre aux heures de début et de fin',
        invalidRate: 'Le tarif doit être compris entre 0 et 999999999999999 avec au maximum 5 décimales',
        rateNameTooLong: 'Le nom du tarif ne peut pas dépasser 255 caractères',
        descriptionTooLong: 'La description ne peut pas dépasser 3000 caractères',
        confirmDelete: 'Cette saisie de temps sera supprimée. Continuer ?'
    },
    setting: {
        taxInfo: 'Informations sur la taxe',
        taxes: 'Taxes',
        taxYearStarts: "Début de l'exercice fiscal",
        taxYearStartSubtitle: "Définir le premier jour de l'exercice fiscal",
        rateLabel: 'Taux(%)',
        abbreviation: 'Abréviation',
        addTax: 'Ajouter une taxe',
        month: 'Mois',
        day: 'Jour',
        monthPlaceholder: 'Mois',
        dayPlaceholder: 'Jour',
        saveTaxYearStart: 'Enregistrer',
        deleteDialogTitle: 'Supprimer',
        confirmDeleteTax: 'Êtes-vous sûr de vouloir supprimer cette taxe ?',
        deleteConfirm: 'Supprimer',
        taxInfoDialogTitle: 'Informations sur la taxe',
        taxName: 'Nom de la taxe',
        standardRate: 'Taux standard (%)',
        additionalRate: 'Taux supplémentaire',
        deleteRateX: 'X',
        addRate: 'Ajouter un taux',
        taxType: 'Type de taxe',
        exclusive: 'Hors taxe',
        inclusive: 'TTC',
        close: 'fermer',
        saveTax: 'Enregistrer la taxe',
        cantOpenDetailMessage: 'Cette taxe contient une taxe cumulative. Le web ne prend pas en charge cette fonction pour le moment',
        closeButton: 'Fermer',
        rateIsRequired: 'le taux est obligatoire',
        rateIsRequiredMsg: 'Le taux est obligatoire',
        monthAndDayRequired: 'Le mois et le jour sont requis',
        additionalRateNumber: 'Taux supplémentaire {number} (%)',
        taxNameRequired: 'Le nom de la taxe est obligatoire',
        invalidTaxRate: 'Le taux doit être compris entre 0 et 999999999999999 avec au maximum 4 décimales',
        duplicateTaxRate: 'Les taux de taxe doivent être uniques',
        taxRatesTooLong: 'Il y a trop de taux de taxe à enregistrer',
        withholdingNameRequired: 'L’abréviation est obligatoire lorsque la retenue est active',
        moreRate: ' taux supplémentaire',
        moreRates: ' taux supplémentaires'
    },
    companyInfo: {
        title: "Informations sur l'entreprise",
        details: 'Détails',
        businessName: "Nom de l'entreprise",
        businessNamePlaceholder: "Nom de l'entreprise",
        name: 'Nom',
        phone: 'Téléphone',
        email: 'E-mail',
        businessNumber: "Numéro d'entreprise",
        taxNo: 'N° fiscal',
        deleteField: 'supprimer',
        addNewField: 'Ajouter un nouveau champ',
        address: 'Adresse',
        line1: 'Ligne1',
        line2: 'Ligne2',
        line3: 'Ligne3',
        currency: 'Devise',
        currencyLabel: 'Devise',
        symbol: 'Symbole',
        placement: 'Emplacement',
        before: 'Avant',
        after: 'Après',
        thousandSymbol: 'Symbole des milliers',
        decimalSymbol: 'Symbole décimal',
        decimalPlaces: 'Décimales',
        example: 'Exemple',
        terms: 'Conditions',
        termsLabel: 'Conditions',
        termSameDay: 'Même jour',
        term7Days: '7 jours',
        term14Days: '14 jours',
        term21Days: '21 jours',
        term30Days: '30 jours',
        term45Days: '45 jours',
        term60Days: '60 jours',
        term90Days: '90 jours',
        term180Days: '180 jours',
        term365Days: '365 jours',
        paymentInfo: 'Informations de paiement',
        displayOnInvoices: 'Afficher sur les factures',
        titlePlaceholder: 'Titre',
        jobDetails: 'Détails du travail',
        deleteJobDetail: 'supprimer',
        addNewJobField: 'ajouter un nouveau champ',
        fieldNameRequired: '{field} : le nom du champ est obligatoire',
        reservedCharacters: '{field} : le nom ne peut pas contenir : ou &&, et la valeur ne peut pas contenir &&',
        serializedDataTooLong: 'Les données de {field} dépassent la limite de la base de données',
        textDataTooLong: '{field} dépasse la limite de la base de données'
    },
    default: {
        title: 'Par défaut',
        emailMessage: "Message de l'e-mail",
        enterDescription: 'Saisir une description',
        emailCc: 'E-mail Cc',
        emailBcc: 'E-mail Cci',
        emailTip: "Envoyer un e-mail en même temps à l'adresse ci-dessus.",
        defaultComments: 'Commentaires par défaut',
        invoice: 'Facture',
        estimate: 'Devis',
        purchaseOrder: 'Bon de commande',
        creditMemo: 'Avoir',
        emailValidError: 'e-mail valide'
    },
    invoiceDesign: {
        template: 'Modèle',
        color: 'Couleur',
        labels: 'Étiquettes',
        labelInvoice: 'Facture',
        labelEstimate: 'Devis',
        labelPurchaseOrder: 'Bon de commande',
        labelCreditMemo: 'Avoir',
        labelReceipt: 'REÇU',
        labelTermsFormat: 'Format des conditions',
        labelBillTo: 'Facturer à',
        labelFor: 'Pour',
        labelDate: 'Date',
        labelInvoiceNo: 'N° de facture',
        labelEstimateNo: 'N° de devis',
        labelPoNo: 'N° de BC',
        labelCreditMemoNo: "N° d'avoir",
        labelDueDate: "Date d'échéance",
        labelTerms: 'Conditions',
        labelAmount: 'Montant',
        labelCode: 'Code',
        labelDescription: 'Description',
        labelQuantity: 'Quantité',
        labelRate: 'Tarif',
        labelTax: 'Taxe',
        labelSubtotal: 'Sous-total',
        labelBalanceDue: 'Solde dû',
        labelDiscount: 'Remise',
        labelNonTaxableItem: 'Article non imposable',
        labelPaid: 'Payé',
        labelShipping: 'Livraison',
        labelTotal: 'Total',
        labelIncludes: 'Inclus',
        labelTotalAmountPaid: 'Montant total payé',
        labelShipDate: "Date d'expédition",
        labelShipTo: 'Expédier à',
        labelShipVia: 'Expédier via',
        labelTrackingNo: 'N° de suivi',
        labelFob: 'F.O.B',
        prefix: 'Préfixe',
        prefixInvoice: 'Facture',
        prefixEstimate: 'Devis',
        prefixPurchaseOrder: 'Bon de commande',
        prefixCreditMemo: 'Avoir',
        nextNumber: 'Prochain numéro',
        numberingBeginsAt: 'La numérotation commence à',
        nextNumberInvoice: 'Facture',
        nextNumberEstimate: 'Devis',
        nextNumberPurchaseOrder: 'Bon de commande',
        nextNumberCreditMemo: 'Avoir',
        options: 'Options',
        optionTerms: 'Conditions',
        optionDueDate: "Date d'échéance",
        optionShippingAddress: 'Adresse de livraison',
        optionProductCode: 'Code produit',
        optionQuantityAndRate: 'Quantité et tarif',
        optionUnit: 'Unité',
        optionTax: 'Taxe',
        optionAmount: 'Montant',
        optionNonTaxableItemStar: "Étoile d'article non imposable",
        optionDiscount: 'Afficher la remise',
        optionTaxBreakdown: 'Décomposition de la taxe',
        optionPaymentHistory: 'Historique des paiements',
        optionStamp: 'Tampon',
        optionPageNumber: 'Numéro de page',
        previewName: 'Robin',
        previewAddress: '726 Building St. #872',
        previewCity: 'Seattle,Washington',
        previewZip: '99999 US',
        previewDate: 'Oct 1,2019',
        previewShipName: 'Peter',
        previewShipDate: 'Oct 2,2019',
        previewShipVia: 'Federal Express',
        previewThanksMessage: "Merci pour votre confiance ! Nous espérons que vous êtes satisfait de notre travail. Veuillez effectuer le paiement dans les 15 jours. Des questions ? Des commentaires ? Contactez-nous au (111)111-1234 ou envoyez-nous un e-mail à example@owner.com, nous serons ravis de répondre à toutes vos questions ou préoccupations.",
        previewSubtotal: 'Sous-total',
        previewVat: 'TVA 17.00%',
        previewPayment1: 'Paiement le 1 Oct 2019',
        previewPayment2: 'Paiement le 2 Oct 2019',
        invalidNextNumber: 'Chaque numéro suivant doit être un entier compris entre 0 et {max}'
    },
    feedback: {
        title: 'Envoyer un commentaire',
        invalidEmailNoticePrefix: "L'adresse e-mail de votre compte n'est pas valide, nous n'avons donc pas pu vous contacter. Veuillez envoyer votre commentaire depuis une adresse e-mail valide à",
        invalidEmailNoticeSuffix: "Si possible, incluez une capture d'écran du problème ; cela nous aidera à l'examiner et à le résoudre.",
        replyTip: "Après l'envoi, veuillez vérifier votre e-mail pour la réponse.",
        contextTip: 'Les informations de compte et de navigateur suivantes seront jointes à votre commentaire :',
        content: 'Contenu',
        enterDescription: 'Saisir une description',
        contentTooLong: 'Le contenu ne peut pas dépasser {max} caractères'
    },
    createExpense: {
        title: 'Ajouter une dépense',
        description: 'Description',
        expenseDescriptionPlaceholder: 'Description de la dépense',
        total: 'Total',
        tax: 'Taxe',
        tip: 'Pourboire',
        expenseDate: 'Date de dépense',
        merchant: 'Marchand',
        merchantPlaceholder: 'Saisir le nom du marchand',
        categoryPlaceholder: 'Sélectionner une catégorie',
        addNewCategory: 'Ajouter une nouvelle catégorie',
        deletePhoto: 'Supprimer',
        addPhoto: 'Ajouter une photo',
        deleteCategory: 'supprimer',
        addCategory: 'Ajouter une catégorie',
        descriptionTooLong: 'La description ne peut pas dépasser 3 000 caractères.',
        merchantTooLong: 'Le nom du commerçant ne peut pas dépasser 255 caractères.',
        amountInvalid: 'Le total, la taxe et le pourboire doivent chacun être compris entre 0 et 999999999999999, avec au maximum 5 décimales.',
        categoryRequired: 'Le nom de la catégorie est obligatoire.',
        categoryTooLong: 'Le nom de la catégorie ne peut pas dépasser 255 caractères.',
        photoUploadFailed: 'Le téléversement de la photo a échoué. Veuillez réessayer.'
    },
    updateExpense: {
        title: 'Mettre à jour la dépense',
        deleteExpense: 'Supprimer la dépense',
        confirmDeleteMsg: 'Cela supprimera la dépense. Continuer ?'
    },
    notFound: {
        oops: 'OOPS !',
        notFoundMsg: "Nous ne parvenons pas à trouver la page que vous recherchez.",
        takeMeHome: "Retour à l'accueil"
    },
    classicPDF: {
        previewName: 'Robin',
        previewAddress: '726 Building St. #872',
        previewCity: 'Seattle,Washington',
        previewZip: '99999 US',
        previewDate: 'Oct 1,2019',
        previewDueDate: 'Nov 15,2019',
        previewShipName: 'Peter',
        previewFreeShipping: 'Livraison gratuite',
        previewShipDate: 'Oct 2,2019',
        previewShipVia: 'Federal Express',
        previewItem1: 'Ordinateur',
        previewItem2: 'Téléphone',
        previewItem3: "Gâteau d'anniversaire",
        previewTaxRate: '17%',
        nonTaxableNote: '* Indique un article non imposable',
        thanksMessage: "Merci pour votre confiance ! Nous espérons que vous êtes satisfait de notre travail. Veuillez effectuer le paiement dans les 15 jours. Des questions ? Des commentaires ? Contactez-nous au (111)111-1234 ou envoyez-nous un e-mail à example@owner.com, nous serons ravis de répondre à toutes vos questions ou préoccupations.",
        subtotal: 'Sous-total',
        vat: 'TVA 17.00%',
        payment1: 'Paiement le 1 Oct 2019',
        payment2: 'Paiement le 2 Oct 2019',
        balanceDue: 'Solde dû'
    }
};
